import { render, staticRenderFns } from "./ResetKataSandi.vue?vue&type=template&id=569216bf&scoped=true&"
import script from "./ResetKataSandi.vue?vue&type=script&lang=js&"
export * from "./ResetKataSandi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569216bf",
  null
  
)

export default component.exports